<!-- frontend/src/views/ToolDescriptionPageView.vue -->
<template>
  <div class="tool-description-view">
    <!-- Header -->
    <Header />

    <!-- Side Navigation -->
    <SideNavigation :sections="sectionsContent" />

    <!-- Language Switcher positioned for documentation only -->
    <div class="language-switcher-container">
      <LanguageSwitcher />
    </div>

    <!-- Main Content Area -->
    <main class="tool-description-main">
      <!-- ToolDescriptionContent provides sections via event -->
      <ToolDescriptionContent
        @sections-content-updated="updateSectionsContent"
      />
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import SideNavigation from '@/components/SideNavigation.vue';
import ToolDescriptionContent from '@/components/ToolDescriptionContent.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';

export default {
  name: 'ToolDescriptionPageView',
  components: {
    Header,
    SideNavigation,
    ToolDescriptionContent,
    LanguageSwitcher
  },
  data() {
    return {
      sectionsContent: [],
    };
  },
  methods: {
    updateSectionsContent(sections) {
      // When ToolDescriptionContent is mounted, 
      // this event is sent, and we populate 
      // 'sectionsContent' for the SideNavigation
      this.sectionsContent = sections;
    }
  },
};
</script>

<style scoped>
.tool-description-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #ffffff;
  overflow-x: hidden;
  width: 100%;
  position: relative;
  padding-top: 80px; /* Add space for fixed header */
}

.tool-description-main {
  flex: 1;
  padding-top: 0;
  margin-top: 0;
  position: relative;
  width: 100%;
}

.language-switcher-container {
  position: fixed;
  top: 100px; /* Below the header */
  right: 20px;
  z-index: 1025;
  background-color: white;
  padding: 8px;
  border-radius: 25px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Desktop Styles */
@media (min-width: 992px) {
  .tool-description-main {
    transition: margin-left 0.3s ease;
  }
}

/* Mobile Styles */
@media (max-width: 991.98px) {
  .tool-description-main {
    margin-left: 0;
  }
  
  .language-switcher-container {
    top: 90px;
    right: 10px;
  }
}
</style>